export const HEADER_SEARCH_QUERY_PARAMETER_ID = 'query';
export const HEADER_SEARCH_CATEGORY_PARAMETER_ID = 'category';

export const SUGGESTIONS_CONTAINER_ID = 'suggestions-container';

export const suggestionsTypes = {
    product: 'product',
    additives: 'additives',
    technology: 'technology',
    video: 'video',
    article: 'article',
    document: 'document',
    other: 'other'
};
